import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { combineLatest } from 'rxjs';
import { SearchForm } from '../helper/search-form';
import { debounceTime, first, switchMap, tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { ICommonResponse } from '../../interfaces/icommon-response';
import { IRegistryState } from '../interfaces/iregistry-state';

/**
 * Оператор для подписки на обновления управляющих компонентов реестра
 * @param searchFormComponent - Форма поиска для реестра
 * @param getListMethod - Сервисный метод получения данных от бека
 * @param getCountMethod - Сервисный метод получения общего количества записей
 * @param beforeRequest - Метод, который отработает перед запросом на сервер
 * @param afterRequest - Метод, который отработает после запроса на сервер
 * @param grid - Флаг получения данных по гриду
 */
export const updateRegistry = (
  searchFormComponent: SearchForm,
  getListMethod: (offset: number, limit: number, searchForm: any, sortParams?: any) => Observable<ICommonResponse>,
  getCountMethod?: ((searchForm: any) => Observable<number>) | null,
  beforeRequest?: (() => void) | null,
  afterRequest?: (() => void) | null,
  grid?: boolean,
): Observable<[{ entities: any }, number]> => {
  return merge(searchFormComponent.storage.queryParams, searchFormComponent.search$).pipe(
    // filter(() => searchFormComponent.needSearch.value),//todo: check
    debounceTime(100),
    switchMap((_) => {
      return of(searchFormComponent.currentState);
    }),
    tap((_) => {
      if (beforeRequest) {
        beforeRequest();
      }
    }),
    switchMap((condition: IRegistryState) => {
      if (!getCountMethod && !grid) {
        return getListMethod(condition.offset, condition.limit, condition.searchForm, condition.sort).pipe(
          switchMap((res) => {
            return combineLatest([
              of({ entities: res?.data?.entities || [] }),
              of(<number>res?.data?.count)
            ]);
          }),
        );
      } else if (!getCountMethod && grid) {
        return getListMethod(condition.offset, condition.limit, condition.searchForm, condition.sort).pipe(
          switchMap((res) => {
            return combineLatest([of({ entities: { items: res?.data?.items || [], additionalItems: res?.data?.additionalItems || []} }), of(res?.data?.count || 0)]);
          }),
        );
      } else {
        return combineLatest([
          getListMethod(condition.offset, condition.limit, condition.searchForm, condition.sort).pipe(
            switchMap((res) => {
              const entities = res?.data?.entities || [];
              return of({ entities });
            }),
          ),
          (getCountMethod as (searchForm: any) => Observable<number>)(condition.searchForm).pipe(
            switchMap((res) => {
              return of(res || 0);
            }),
          ),
        ]).pipe(first());
      }
    }),
    tap(([list, count]) => {
      if (count !== null) {
        searchFormComponent.countItems = count;
      }
    }),
    tap((_) => {
      if (afterRequest) {
        afterRequest();
      }
    }),
  );
};
